interface LocalHealthCondition {
  healthId: string;
  breeds: string[];
  isRecommendedByEmbark: boolean;
  isRecommendedByOFA: boolean;
  condition: Partial<{
    health_id: string;
    category: string;
    lay_term: string;
    disorder_name: string;
    subdisorder_name: string;
    subdisorder_description: string;
    gene: string;
    moi: string;
    reference_1_text: string;
    reference_1_link: string;
    reference_2_text: string;
    reference_2_link: string;
    reference_3_text: string;
    reference_3_link: string;
    reference_4_text: string;
    reference_4_link: string;
    reference_5_text: string;
    reference_5_link: string;
    is_linkage_test_for_v1: 'TRUE' | 'FALSE';
    is_linkage_test_for_v2: 'TRUE' | 'FALSE';
    is_linkage_test_for_v3: 'TRUE' | 'FALSE';
    is_linkage_test_for_v4: 'TRUE' | 'FALSE';
    is_linkage_test_for_v5: 'TRUE' | 'FALSE';
    is_linkage_test_for_v6: 'TRUE' | 'FALSE';
    is_linkage_test_for_v7: 'TRUE' | 'FALSE';
    consumer_brief_description_required: string;
    consumer_additional_description: string;
    layperson_name: string;
    abbreviated_name: string;
    is_ancestry_based_risk: boolean;
  }>;
}
export const localHealthConditions: Record<string, LocalHealthCondition> = {
  '000000': {
    healthId: '000000',
    breeds: [
      'Alapaha Blue Blood Bulldog',
      'American Bulldog',
      'American Bully',
      'American Pit Bull Terrier',
      'American Staffordshire Terrier',
      'Boston Terrier',
      'Boxer',
      'Bull Terrier',
      'English Bulldog',
      'Dogo Argentino',
      'French Bulldog',
      'Miniature Bull Terrier',
      'Olde English Bulldogge',
      'Staffordshire Bull Terrier',
      'Staffordshire Terrier',
    ],
    isRecommendedByEmbark: true,
    isRecommendedByOFA: false,
    condition: {
      health_id: '000000',
      category: 'Skin & Connective Tissues',
      lay_term: 'Skin & Connective Tissues',
      disorder_name: 'Mast Cell Tumor',
      subdisorder_name: '(MCT)',
      subdisorder_description: '',
      gene: 'Multiple',
      moi: '',
      consumer_brief_description_required:
        'Mast cell tumor (MCT) is the most common malignant skin tumor in dogs. These tumors consist of white blood cells and tend to form masses in or under the skin on the head, neck, limbs, and trunk, but can also affect some internal organs. The average age of onset is 7 years, although tumors may develop at any age. The majority of MCTs can be cured by surgery alone.',
      consumer_additional_description: '',
      layperson_name: 'Mast Cell Tumor',
      abbreviated_name: 'MCT',
      is_ancestry_based_risk: true,
    },
  },
};

export const isLocalCopyAvailable = (id: string): boolean => {
  return localHealthConditions.hasOwnProperty(id);
};

export const getLocalCopy = (id: string): Record<string, any> | null => {
  if (!isLocalCopyAvailable(id)) {
    return null;
  }

  return localHealthConditions[id];
};

export const getLocalHealthCopiesByBreed = (
  breed: string
): LocalHealthCondition[] => {
  return Object.values(localHealthConditions).filter((health) => {
    return health.breeds.includes(breed);
  });
};
